import { createTheme } from '@mui/material/styles';

const muiTheme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          fontFamily: ['Rubik', 'Helvetica', 'Arial', 'sans-serif'].join(','),
        },
        '#root': {
          minHeight: '100vh',
          display: 'flex',
        },
      },
    },
    MuiButton: {
      defaultProps: {
        variant: 'contained',
      },
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: 100,
          backgroundColor: theme.palette.grey[600],

          '&:hover': {
            backgroundColor: theme.palette.grey[700],
          },
        }),
      },
    },
  },
});

export default muiTheme;
